export default {
  setMode(state, mode) {
    state.mode = mode;
  },
};
